export default {
  load_error_title: "文档加载失败",
  load_error_subtitle: "抱歉，文档无法加载。请稍后再试。",
};
